(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faf-financing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faf-financing')) {
    customElements.define('faf-financing', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.copy = JSON.parse(this.querySelector('[data-finance-copy]').textContent);
        this.answers = this.answers || {};
        this.step = this.step || 0;
        this.fields = ['credit', 'budget', 'schedule'];
        const locale = document.documentElement.lang || 'en-US';
        const currency = this.dataset.currency || 'USD';
        this.money = new Intl.NumberFormat(locale, {style:'currency', currency, minimumFractionDigits:2, maximumFractionDigits:2});
        this.wholeMoney = new Intl.NumberFormat(locale, {style:'currency', currency, maximumFractionDigits:0});
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-action]');
          if (!button || !this.contains(button)) return;
          if (button.dataset.action === 'back') { this.step = Math.max(0, this.step - 1); this.showStep(true); }
          if (button.dataset.action === 'next' && this.answers[this.fields[this.step]]) {
            if (this.step < 2) { this.step += 1; this.showStep(true); } else this.showResult();
          }
          if (button.dataset.action === 'restart') {
            this.answers = {}; this.step = 0;
            this.querySelectorAll('[data-question]').forEach(input => { input.checked = false; });
            this.showStep(true);
          }
        }, {signal:this.controller.signal});
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-question]') && event.target.checked) {
            this.answers[event.target.dataset.question] = event.target.value;
            this.querySelector('[data-action="next"]').disabled = !this.answers[this.fields[this.step]];
          }
          if (event.target.matches('[data-term]')) this.updatePayment();
        }, {signal:this.controller.signal});
        this.addEventListener('input', (event) => {
          if (event.target.matches('[data-amount-range]')) { this.querySelector('[data-exact-amount]').value = event.target.value; this.updatePayment(); }
          if (event.target.matches('[data-exact-amount]')) this.updatePayment();
        }, {signal:this.controller.signal});
        if (!this.amountInitialized) {
          const supplied = new URLSearchParams(window.location.search).get('amount');
          const amount = supplied !== null && /^\d+(?:\.\d{1,2})?$/.test(supplied) ? Number(supplied) : NaN;
          if (Number.isFinite(amount) && amount >= 0.01 && amount <= 1000000) this.querySelector('[data-exact-amount]').value = amount.toFixed(2);
          this.amountInitialized = true;
        }
        if (this.querySelector('[data-quiz-result]').hidden) this.showStep(false);
        this.syncFormState();
        window.addEventListener('pageshow', () => this.scheduleFormStateSync(), {signal:this.controller.signal});
        this.scheduleFormStateSync();
        this.querySelector('[data-quiz]').hidden = false;
        this.querySelector('[data-calculator]').hidden = false;
        if (!this.estimatorAnchorHandled && window.location.hash === '#payment-estimator') {
          this.estimatorAnchorHandled = true;
          requestAnimationFrame(() => { if (this.isConnected) this.querySelector('[data-calculator]').scrollIntoView({block:'start'}); });
        }
        this.querySelectorAll('[data-finder-link]').forEach(link => { link.setAttribute('href', '#' + this.querySelector('[data-quiz]').id); });
      }
      disconnectedCallback() { this.controller?.abort(); clearTimeout(this.restoreTimer); }
      scheduleFormStateSync() {
        clearTimeout(this.restoreTimer);
        // History restoration can finish after pageshow, without input/change events.
        this.restoreTimer = setTimeout(() => { if (this.isConnected) this.syncFormState(); }, 0);
      }
      syncFormState() {
        const restoredAnswers = {};
        this.querySelectorAll('[data-question]:checked').forEach(input => { restoredAnswers[input.dataset.question] = input.value; });
        const changed = this.fields.some(field => this.answers[field] !== restoredAnswers[field]);
        this.answers = restoredAnswers;
        if (!this.querySelector('[data-quiz-result]').hidden) {
          const missingStep = this.fields.findIndex(field => !this.answers[field]);
          if (missingStep !== -1) { this.step = missingStep; this.showStep(false); }
          else if (changed) this.showResult(false);
        } else {
          this.querySelector('[data-action="next"]').disabled = !this.answers[this.fields[this.step]];
        }
        this.updatePayment();
      }
      showStep(focus) {
        this.querySelector('[data-quiz-result]').hidden = true;
        this.querySelector('[data-quiz-questions]').hidden = false;
        this.querySelectorAll('[data-quiz-step]').forEach((step, index) => { step.hidden = index !== this.step; });
        this.querySelectorAll('[data-progress-step]').forEach((segment, index) => { segment.classList.toggle('is-active', index <= this.step); });
        this.querySelector('[data-step-status]').textContent = this.copy.progress.replace('{current}', this.step + 1).replace('{total}', 3);
        this.querySelector('[data-action="back"]').hidden = this.step === 0;
        const next = this.querySelector('[data-action="next"]');
        next.textContent = this.step === 2 ? this.copy.finish : this.copy.next;
        next.disabled = !this.answers[this.fields[this.step]];
        if (focus) this.querySelector(`[data-quiz-step="${this.step}"] [data-step-heading]`).focus();
      }
      recommendedProgram() {
        if (this.answers.schedule === 'save' || this.answers.credit === 'prefer') return 'layaway';
        if (this.answers.schedule === 'weekly' || this.answers.credit === 'none') return 'lease';
        if (this.answers.credit === 'building') return this.answers.budget === 'under500' ? 'help' : 'fortiva';
        return 'synchrony';
      }
      showResult(focus = true) {
        const key = this.recommendedProgram();
        const program = this.querySelector(`[data-program="${key}"]`);
        const title = this.querySelector('[data-result-title]');
        const link = this.querySelector('[data-result-link]');
        const programLink = program?.querySelector('[data-program-link]');
        title.textContent = program?.querySelector('[data-program-name]')?.textContent.trim() || this.copy.helpTitle;
        this.querySelector('[data-result-description]').textContent = this.copy.results[program ? key : 'help'];
        link.textContent = programLink?.textContent.replace('↗', '').trim() || this.copy.helpButton;
        link.setAttribute('href', programLink?.getAttribute('href') || '/pages/contact');
        this.querySelector('[data-quiz-questions]').hidden = true;
        this.querySelector('[data-quiz-result]').hidden = false;
        if (focus) title.focus();
      }
      updatePayment() {
        const slider = this.querySelector('[data-amount-range]');
        const exact = this.querySelector('[data-exact-amount]');
        const amount = Number(exact.value);
        if (!exact.value || !exact.validity.valid || !Number.isFinite(amount) || amount <= 0) {
          this.querySelector('[data-payment]').textContent = '—';
          return;
        }
        slider.max = String(Math.max(10000, Math.ceil(amount / 1000) * 1000));
        slider.value = String(amount);
        const selectedTerm = this.querySelector('[data-term]:checked') || this.querySelector('[data-term][value="60"]');
        selectedTerm.checked = true;
        const term = Number(selectedTerm.value);
        const isMinimum = term === 12;
        this.querySelector('[data-min-amount]').textContent = this.money.format(Number(slider.min));
        this.querySelector('[data-max-amount]').textContent = this.wholeMoney.format(Number(slider.max));
        slider.setAttribute('aria-valuetext', this.money.format(amount));
        this.querySelector('[data-payment]').textContent = this.money.format(isMinimum ? amount * 0.035 : amount / term);
        this.querySelector('[data-payment-heading]').textContent = isMinimum ? this.copy.calculator.minimumHeading : this.copy.calculator.equalHeading;
        this.querySelector('[data-payment-period]').textContent = isMinimum ? this.copy.calculator.minimumPeriod : this.copy.calculator.equalPeriod;
        this.querySelector('[data-payment-note]').textContent = isMinimum ? this.copy.calculator.minimumNote : this.copy.calculator.equalNote;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faf-home-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const start = root => {
    root.querySelectorAll('[data-faf-tent-switch]').forEach(switcher => {
      if (switcher.dataset.fafTentReady) return;
      switcher.dataset.fafTentReady = 'true';
      const begins = Date.parse(switcher.dataset.start);
      const ends = Date.parse(switcher.dataset.end);
      const finalDay = Date.parse(switcher.dataset.finalDay);
      let timer;
      const cleanup = () => {
        clearTimeout(timer);
        document.removeEventListener('visibilitychange', update);
        window.removeEventListener('pageshow', update);
      };
      const update = () => {
        clearTimeout(timer);
        if (!switcher.isConnected) { cleanup(); return; }
        const now = Date.now();
        if (!Number.isFinite(begins) || !Number.isFinite(ends) || now < begins || now >= ends) {
          const fallback = switcher.querySelector('[data-faf-tent-fallback]');
          if (fallback) switcher.replaceChildren(fallback.content.cloneNode(true));
          cleanup();
          return;
        }
        const phrase = switcher.querySelector('[data-tent-phrase]');
        if (phrase) phrase.textContent = now >= finalDay ? phrase.dataset.final : phrase.dataset.extended;
        const next = now < finalDay ? finalDay : ends;
        timer = setTimeout(update, Math.max(1, Math.min(next - now + 25, 60000)));
      };
      document.addEventListener('visibilitychange', update);
      window.addEventListener('pageshow', update);
      update();
    });
  };
  start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faf-home-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faf-home-products')) {
    customElements.define('faf-home-products', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.rail = this.querySelector('[data-product-rail]');
        this.controls = this.querySelector('[data-rail-controls]');
        this.previous = this.querySelector('[data-rail-previous]');
        this.next = this.querySelector('[data-rail-next]');
        if (!this.rail || !this.controls || !this.previous || !this.next) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateControls());
        };
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.rail.addEventListener('scroll', schedule, { passive: true, signal });
        window.addEventListener('pageshow', schedule, { signal });
        this.resizeObserver = new ResizeObserver(schedule);
        this.resizeObserver.observe(this.rail);
        schedule();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      updateControls() {
        const maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
        const offset = getComputedStyle(this.rail).direction === 'rtl' ? -this.rail.scrollLeft : this.rail.scrollLeft;
        const position = Math.max(0, Math.min(maximum, offset));
        this.controls.hidden = maximum <= 1;
        this.previous.disabled = position <= 1;
        this.next.disabled = maximum - position <= 1;
      }
      move(direction) {
        const firstCard = this.rail.firstElementChild;
        if (!firstCard) return;
        const style = getComputedStyle(this.rail);
        const distance = firstCard.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
        const factor = style.direction === 'rtl' ? -1 : 1;
        this.rail.scrollBy({
          left: distance * direction * factor,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faf-home-top-ten"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faf-home-top-ten')) {
    customElements.define('faf-home-top-ten', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.clearModalFocus();
        this.modalObservers = [];
        this.modalFrames = new Map();
        this.rail = this.querySelector('[data-product-rail]');
        this.controls = this.querySelector('[data-rail-controls]');
        this.navigation = this.querySelector('[data-rail-navigation]');
        this.range = this.querySelector('[data-rail-range]');
        this.progress = this.querySelector('[data-rail-progress]');
        this.previous = this.querySelector('[data-rail-previous]');
        this.next = this.querySelector('[data-rail-next]');
        if (!this.rail || !this.controls || !this.previous || !this.next) return;
        this.querySelectorAll('modal-opener .card__link').forEach(button => {
          button.removeAttribute('tabindex');
          button.classList.remove('card-focused');
          const selector = button.closest('modal-opener')?.getAttribute('data-modal');
          const modal = selector ? document.querySelector(selector) : null;
          if (!modal) return;
          const observer = new MutationObserver(() => {
            cancelAnimationFrame(this.modalFrames.get(modal));
            this.modalFrames.delete(modal);
            if (!modal.hasAttribute('open') || !this.contains(modal.openedBy)) return;
            this.modalFrames.set(modal, requestAnimationFrame(() => {
              this.modalFrames.set(modal, requestAnimationFrame(() => {
                this.modalFrames.delete(modal);
                if (!this.isConnected || !modal.isConnected || !modal.hasAttribute('open') || !this.contains(modal.openedBy)) return;
                if (!modal.contains(document.activeElement)) modal.querySelector('[role="dialog"]')?.focus({preventScroll:true});
              }));
            }));
          });
          observer.observe(modal, {attributes:true, attributeFilter:['open']});
          this.modalObservers.push(observer);
        });
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateControls());
        };
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.rail.addEventListener('scroll', schedule, { passive: true, signal });
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail) return;
          const rtl = getComputedStyle(this.rail).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          }
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.rail.scrollTo({left: event.key === 'Home' ? 0 : (this.rail.scrollWidth - this.rail.clientWidth) * (rtl ? -1 : 1), behavior: 'auto'});
          }
        }, { signal });
        window.addEventListener('pageshow', schedule, { signal });
        this.resizeObserver = new ResizeObserver(schedule);
        this.resizeObserver.observe(this.rail);
        schedule();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.clearModalFocus();
      }
      clearModalFocus() {
        this.modalObservers?.forEach(observer => observer.disconnect());
        this.modalFrames?.forEach(frame => cancelAnimationFrame(frame));
      }
      updateControls() {
        const maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
        const offset = getComputedStyle(this.rail).direction === 'rtl' ? -this.rail.scrollLeft : this.rail.scrollLeft;
        const position = Math.max(0, Math.min(maximum, offset));
        this.controls.hidden = maximum <= 1;
        this.previous.disabled = position <= 1;
        this.next.disabled = maximum - position <= 1;
        const cards = Array.from(this.rail.children);
        const bounds = this.rail.getBoundingClientRect();
        const visible = cards.map((card, index) => {
          const rect = card.getBoundingClientRect();
          return Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) > rect.width * .6 ? index + 1 : null;
        }).filter(Boolean);
        const first = visible[0] || 1;
        const last = visible[visible.length - 1] || first;
        const pad = number => String(number).padStart(2, '0');
        if (this.range) this.range.textContent = (first === last ? pad(first) : pad(first) + '–' + pad(last)) + ' / ' + pad(cards.length);
        if (this.progress) {
          const fraction = Math.min(1, this.rail.clientWidth / this.rail.scrollWidth);
          this.progress.style.width = (fraction * 100) + '%';
          this.progress.style.insetInlineStart = maximum ? (position / maximum * (1 - fraction) * 100) + '%' : '0%';
        }
        if (this.navigation) this.navigation.hidden = cards.length <= 1;
      }
      move(direction) {
        const firstCard = this.rail.firstElementChild;
        if (!firstCard) return;
        const style = getComputedStyle(this.rail);
        const distance = firstCard.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
        const factor = style.direction === 'rtl' ? -1 : 1;
        this.rail.scrollBy({
          left: distance * direction * factor,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faf-store-locator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faf-store-locator')) {
    customElements.define('faf-store-locator', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.cards = Array.from(this.querySelectorAll('[data-locator-card]'));
        this.form = this.querySelector('[data-locator-search-form]');
        this.input = this.querySelector('[data-locator-search]');
        this.map = this.querySelector('[data-locator-iframe]');
        this.copy = JSON.parse(this.querySelector('[data-locator-copy]').textContent);
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.filterStores();
        }, { signal: this.controller.signal });
        this.addEventListener('click', (event) => {
          const card = event.target.closest('[data-locator-card]');
          if (!card || !this.contains(card) || card.hidden || event.target.closest('a')) return;
          this.selectStore(card, true);
        }, { signal: this.controller.signal });
        this.input.addEventListener('search', () => {
          if (!this.input.value) this.filterStores();
        }, { signal: this.controller.signal });
        window.addEventListener('pageshow', () => {
          clearTimeout(this.restoreTimer);
          this.restoreTimer = setTimeout(() => {
            if (this.isConnected) this.filterStores(false);
          }, 0);
        }, { signal: this.controller.signal });
        this.cards.forEach(card => {
          card.querySelector('[data-locator-select]').disabled = false;
          card.setAttribute('data-locator-ready', '');
        });
        this.form.hidden = false;
        this.querySelector('[data-locator-search-helper]').hidden = false;
        this.filterStores(false);
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.restoreTimer);
      }
      filterStores(announce = true) {
        const normalize = value => String(value).trim().toLocaleLowerCase().replace(/\s+/g, ' ');
        const query = normalize(this.input.value);
        const matches = this.cards.filter(card => {
          const matchesQuery = normalize(card.dataset.locatorMatch).includes(query);
          card.hidden = !matchesQuery;
          return matchesQuery;
        });
        this.querySelector('[data-locator-count]').textContent = matches.length === 1 ? this.copy.one : this.copy.many.replace('__COUNT__', matches.length);
        this.querySelector('[data-locator-no-results]').hidden = matches.length !== 0;
        this.selectStore(matches[0] || null, announce);
      }
      selectStore(selected, announce = true) {
        this.cards.forEach(card => {
          const active = card === selected;
          card.classList.toggle('is-selected', active);
          card.querySelector('[data-locator-select]').setAttribute('aria-pressed', String(active));
        });
        this.map.hidden = !selected;
        this.querySelector('[data-locator-empty-map]').hidden = Boolean(selected);
        if (selected) {
          if (this.map.getAttribute('src') !== selected.dataset.locatorMap) this.map.setAttribute('src', selected.dataset.locatorMap);
          this.map.setAttribute('title', selected.dataset.locatorMapTitle);
        } else {
          this.map.removeAttribute('src');
        }
        this.querySelector('[data-locator-map-status]').textContent = announce && selected ? selected.dataset.locatorStatus : '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.elements.button.addEventListener('click', this.togglePanel.bind(this));
      this.addEventListener('keydown', this.onEscapePress.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    connectedCallback() {
      document.addEventListener('click', this.handleDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocumentClick);
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    showPanel() {
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.panel.removeAttribute('hidden');
    }

    togglePanel() {
      if (this.elements.button.getAttribute('aria-expanded') === 'true') {
        this.hidePanel();
      } else {
        this.showPanel();
      }
    }

    onEscapePress(event) {
      if (event.key === 'Escape') {
        this.hidePanel();
      }
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
      this.hidePanel();
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.hasOverlay = this.header.classList.contains('has-overlay');

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (this.headerIsAlwaysSticky) this.reveal;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && (
        this.predictiveSearch.contains(document.activeElement) ||
        this.predictiveSearch.pointerInside ||
        this.predictiveSearch.isOpen ||
        this.predictiveSearch.promoModal?.classList.contains('search__modal--hidden') === false
      )) {
        this.currentScrollTop = scrollTop;
        return;
      }
      const headerTop = document.querySelector('.shopify-section-header .header__top');
      const headerSearch = document.querySelector('.shopify-section-header .search__content');
      const headerBottom = document.querySelector('.shopify-section-header .header__bottom');

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
      }

      if (this.hasOverlay && this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
        this.header.classList.remove('color-background-3');
        headerTop.classList.remove('color-background-3');
        headerBottom?.classList?.remove('color-background-3');
        headerSearch.classList.remove('color-background-3');
        this.header.style.transition = 'background var(--duration-short)';
        this.header.style.transform = 'translateY(0)';
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
        if (this.hasOverlay) {
          this.header.style.transform = 'translateY(0)';
          this.header.style.transition = 'background var(--duration-short)';

          if (this.header.classList.contains('color-background-1')) {
            this.header.classList.add('color-background-3');
            headerTop.classList.add('color-background-3');
            headerSearch.classList.add('color-background-3');
            headerBottom?.classList?.add('color-background-3');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.predictiveSearch && this.predictiveSearch.onBlur) {
          this.predictiveSearch.onBlur();
        }
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      const headerTop = document.querySelector('.shopify-section-header .header__top');
      const headerSearch = document.querySelector('.shopify-section-header .search__content');
      const headerBottom = document.querySelector('.shopify-section-header .header__bottom');

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.hasOverlay) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden', 'color-background-3');
        headerTop.classList.remove('color-background-3');
        headerSearch.classList.remove('color-background-3');
        headerBottom?.classList?.remove('color-background-3');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      const headerTop = document.querySelector('.shopify-section-header .header__top');
      const headerSearch = document.querySelector('.shopify-section-header .search__content');
      const headerBottom = document.querySelector('.shopify-section-header .header__bottom');

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.header.classList.contains('color-background-1') && this.hasOverlay) {
        this.header.classList.add('color-background-3');
        headerTop.classList.add('color-background-3');
        headerBottom?.classList?.add('color-background-3');
        headerSearch.classList.add('color-background-3');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => disclosure.close());
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('collection-layout-switcher')) {
    customElements.define('collection-layout-switcher', class extends HTMLElement {
      connectedCallback() {
        this.layout = this.closest('.collection-grid-layout');
        if (!this.layout) return;
        this.choices = { desktop: ['3', '5'], mobile: ['1', '2'] };
        Object.keys(this.choices).forEach((device) => {
          let value = this.layout.getAttribute(`data-grid-${device}`);
          if (!this.choices[device].includes(value)) {
            try {
              value = sessionStorage.getItem(`collection-grid-${device}`);
            } catch {}
          }
          this.applyChoice(device, this.choices[device].includes(value) ? value : this.choices[device][0]);
        });
        this.onChoice = (event) => {
          const button = event.target.closest('button[data-grid-device]');
          if (!button || !this.contains(button)) return;
          const device = button.dataset.gridDevice;
          const value = button.dataset.gridColumns;
          if (!this.choices[device]?.includes(value)) return;
          this.applyChoice(device, value);
          try {
            sessionStorage.setItem(`collection-grid-${device}`, value);
          } catch {}
        };
        this.addEventListener('click', this.onChoice);
        this.hidden = false;
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onChoice);
      }

      applyChoice(device, value) {
        this.layout.setAttribute(`data-grid-${device}`, value);
        this.querySelectorAll(`button[data-grid-device="${device}"]`).forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.gridColumns === value));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  class RelatedProduct extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const related = html.querySelector('.related-product');
            if (related && related.innerHTML.trim().length) {
              this.innerHTML = related.innerHTML;
            }

            /* Toggle content */
            $('.product-description-more').click(function (e) {
              e.preventDefault();
              $(this).closest('.product-description-short').next().show();
              $(this).closest('.product-description-short').hide();
            });

            $('.product-description-less').click(function (e) {
              e.preventDefault();
              $(this).closest('.product-description-full').prev().show();
              $(this).closest('.product-description-full').hide();
            });
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  class RelatedSlider extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const relatedSlider = html.querySelector(`related-slider[data-id="${this.getAttribute('data-id')}"]`);
            if (relatedSlider && relatedSlider.innerHTML.trim().length) {
              this.innerHTML = relatedSlider.innerHTML;
            }

            /* Related products slider */
            const slider = this.querySelector('.related-slider__list');
            const prevBtn = this.querySelector('.related-slider__button-prev');
            const nextBtn = this.querySelector('.related-slider__button-next');
            const twoColumns = this.querySelector('.swiper-wrapper-2-mobile');
            if (twoColumns && document.querySelector('.related-slider__list')) {
              const productSlider = new Swiper(slider, {
                slidesPerView: 2,
                spaceBetween: 10,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                simulateTouch: true,
                allowTouchMove: true,
                watchSlidesProgress: true,
                preventInteractionOnTransition: true,
                mousewheel: {
                  forceToAxis: true,
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                },
              });
            } else if (document.querySelector('.related-slider__list')) {
              const productSlider = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                simulateTouch: true,
                allowTouchMove: true,
                watchSlidesProgress: true,
                preventInteractionOnTransition: true,
                mousewheel: {
                  forceToAxis: true,
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                },
              });
            }

            /* Color swatches */
            const generateSrcset = (image, widths = []) => {
              const imageUrl = new URL(image['src']);
              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {
                  imageUrl.searchParams.set('width', width.toString());
                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };

            const createImageElement = (image, classes, sizes, productTitle) => {
              const previewImage = image['preview_image'];
              const newImage = new Image(previewImage['width'], previewImage['height']);
              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];
              newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
              newImage.loading = 'lazy';
              return newImage;
            };

            const checkSwatches = () => {
              document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
                wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
                  input.addEventListener('click', (event) => {
                    const primaryImage = wrapper.querySelector('.media--first');
                    const secondaryImage = wrapper.querySelector('.media--second');
                    const handleProduct = wrapper.dataset.product;

                    if (event.currentTarget.checked && primaryImage) {
                      wrapper
                        .querySelector('.js-color-swatches-link')
                        .setAttribute('href', event.currentTarget.dataset.variantLink);
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"]')
                          .setAttribute('aria-disabled', false);
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] > span')
                          .classList.remove('hidden');
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                          .classList.add('hidden');
                        wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
                          event.currentTarget.dataset.variantId;
                      }

                      const currentColor = event.currentTarget.value;

                      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
                        const variant = product.variants.filter(
                          (item) => item.featured_media != null && item.options.includes(currentColor)
                        )[0];

                        if (variant) {
                          const newPrimaryImage = createImageElement(
                            variant['featured_media'],
                            primaryImage.className,
                            primaryImage.sizes,
                            product.title
                          );

                          if (newPrimaryImage.src !== primaryImage.src) {
                            let flag = false;
                            if (secondaryImage) {
                              const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                              const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                              if (secondaryImagePathname == newPrimaryImagePathname) {
                                primaryImage.remove();
                                secondaryImage.classList.remove('media--second');
                                secondaryImage.classList.add('media--first');
                                flag = true;
                              }
                            }
                            if (flag == false) {
                              primaryImage.animate(
                                { opacity: [1, 0] },
                                { duration: 200, easing: 'ease-in', fill: 'forwards' }
                              ).finished;
                              setTimeout(function () {
                                primaryImage.replaceWith(newPrimaryImage);
                                newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' });
                                if (secondaryImage) {
                                  secondaryImage.remove();
                                }
                              }, 200);
                            }
                          }
                        }
                      });
                    }
                  });
                });
              });
            };

            checkSwatches();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('related-product', RelatedProduct);
  customElements.define('related-slider', RelatedSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            /* Color swatches */
            const generateSrcset = (image, widths = []) => {
              const imageUrl = new URL(image['src']);
              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {
                  imageUrl.searchParams.set('width', width.toString());
                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };

            const createImageElement = (image, classes, sizes, productTitle) => {
              const previewImage = image['preview_image'];
              const newImage = new Image(previewImage['width'], previewImage['height']);
              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];
              newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
              newImage.loading = 'lazy';
              return newImage;
            };

            const checkSwatches = () => {
              document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
                wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
                  input.addEventListener('click', (event) => {
                    const primaryImage = wrapper.querySelector('.media--first');
                    const secondaryImage = wrapper.querySelector('.media--second');
                    const handleProduct = wrapper.dataset.product;

                    if (event.currentTarget.checked && primaryImage) {
                      wrapper
                        .querySelector('.js-color-swatches-link')
                        .setAttribute('href', event.currentTarget.dataset.variantLink);
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"]')
                          .setAttribute('aria-disabled', false);
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] > span')
                          .classList.remove('hidden');
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                          .classList.add('hidden');
                        wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
                          event.currentTarget.dataset.variantId;
                      }

                      const currentColor = event.currentTarget.value;

                      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
                        const variant = product.variants.filter(
                          (item) => item.featured_media != null && item.options.includes(currentColor)
                        )[0];

                        if (variant) {
                          const newPrimaryImage = createImageElement(
                            variant['featured_media'],
                            primaryImage.className,
                            primaryImage.sizes,
                            product.title
                          );

                          if (newPrimaryImage.src !== primaryImage.src) {
                            let flag = false;
                            if (secondaryImage) {
                              const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                              const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                              if (secondaryImagePathname == newPrimaryImagePathname) {
                                primaryImage.remove();
                                secondaryImage.classList.remove('media--second');
                                secondaryImage.classList.add('media--first');
                                flag = true;
                              }
                            }
                            if (flag == false) {
                              primaryImage.animate(
                                { opacity: [1, 0] },
                                { duration: 200, easing: 'ease-in', fill: 'forwards' }
                              ).finished;
                              setTimeout(function () {
                                primaryImage.replaceWith(newPrimaryImage);
                                newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' });
                                if (secondaryImage) {
                                  secondaryImage.remove();
                                }
                              }, 200);
                            }
                          }
                        }
                      });
                    }
                  });
                });
              });
            };

            checkSwatches();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
